import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import React, { ChangeEvent } from 'react';
import {
  getRandomInt,
  isANumber,
  convertDigitToProperFormat,
} from 'utils/number';
import {
  AddQuestion,
  Answer,
  AQuestionOption,
  ImportExcelContainer,
  ImportLabelExcel,
  InstructionsContainer,
  InstructionsText,
  NotificationContainer,
  NotificationContentContainer,
  Options,
  QuestionContainer,
  QuestionHeader,
  QuestionOptionsWithAnswer,
  RepeatedQuestion,
  SaveButton,
  SurveyEditorHeaderWrapper,
  ActionButtonContainer,
  NotificationBadgeContainer,
  ContentContainer,
  SelectedFileListContainer,
  ItemsWrapper,
  AttachedFileContent,
  PreviewTable,
  ButtonGroupContainer,
  AIButton,
} from './styles';
import messages from './Messages';
import Dropdown from 'components/Dropdown';
import Icon from 'components/Icon';
import Button from 'components/Button';
import APopover from '../../../../APopover';
import notify from '../../../../Notify';
import Notify, { notifyError } from '../../../../Notify/Notify';
import cloneDeep from 'lodash/cloneDeep';
import {
  FileQuestion,
  GridQuestion,
  IChoiceView,
  IFormValues,
  IMultipleChoiceQuestionView,
  IndicatorQuestion,
  IQuestionsView,
  IQuestionsViewWithData,
  IQuestionTags,
  ISurveyItem,
  ISurveyView,
  ISurveyViewWithData,
  MultipleAnswerQuestion,
  MultipleChoiceQuestion,
  QuestionState,
  QuestionType,
  TextQuestion,
} from 'store/survey/surveyTypes';
import { requireProviderTags } from 'store/providers/providerSlice';
import {
  addQuestion,
  addQuestionAction,
  reindexSurvey,
  updateQuestion,
  updateQuestionAction,
  updateSurvey,
} from 'store/survey/surveySlice';
import {
  IProviderItemViewWithData,
  IProviders,
} from '../../../../../store/providers/providerTypes';
import FileQuestionViewer from './FileQuestion/FileQuestionViewer';
import GridQuestionViewer from './GridQuestion/GridQuestionViewer';
import IndicatorQuestionViewer from './IndicatorQuestion/IndicatorQuestionViewer';
import MultipleAnswerQuestionViewer from './MultipleAnswerQuestion/MultipleAnswerQuestionViewer';
import MultiChoiceQuestionViewer from './MultiChoiceQuestion/MultiChoiceQuestionViewer';
import TextQuestionViewer from './TextQuestion/TextQuestionViewer';
import { HintIcon, QuestionHintBox } from './GeneralQuestion/styles';
import { HintText } from '../../../../../containers/LoginPage/LoginCard/styles';
import { List } from '../../../../../containers/Tasks/TasksManagement/styles';
import { mergeRefs } from '../../../../../utils/happyFunctions';
import QuestionExplorerModal from './QuestionExplorerModal/QuestionExplorerModal';
import { ICompany } from '../../../../../store/companies/companiesTypes';
import * as ExcelJS from 'exceljs';
import Modal from '../../../../Modal/Modal';
import { QuestionTitle } from '../../../../SurveyResponses/TitleInput/styles';
import { appDispatch, RootState } from '../../../../../store/store';
import i18n, { languageDirection } from '../../../../../i18n';
import Input from '../../../../Input/Input';
import { DragDropFilePicker } from '../../../../DragDropFilePicker/DragDropFilePicker';
import LocalIcon from '../../../../../ui/LocalIcon';
import { black, blue, green, red } from '../../../../../utils/style/colors';
import { BadgeContainer } from '../../../../../containers/Tasks/GeneralSearch';
import { summerizeText } from '../../../../../utils/summerizeText';
import { checkFileFormat } from '../../../../../utils/check-file-type/checkFileFormat';
import { connect, MapStateToProps } from 'react-redux';
import IconTypes from '../../../../Icon/IconTypes';
import CKEditorField, {
  CkEditorBaseConfig,
} from '../../../../CKEditorField/CKEditorField';
import { display } from '../../../../ErrorView/ErrorDialog';
import { Formik, FormikProps } from 'formik';
import { generateQuestionViaAI } from '../../../../../api/ManApi';

const { Menu, MenuItem } = Dropdown;

const popperModifier = {
  preventOverflow: {
    boundariesElement: 'viewport',
  },
};

const questions = {
  file: FileQuestion,
  grid: GridQuestion,
  indicator: IndicatorQuestion,
  multipleAnswer: MultipleAnswerQuestion,
  multipleChoice: MultipleChoiceQuestion,
  text: TextQuestion,
};

const questionViewers = {
  file: FileQuestionViewer,
  grid: GridQuestionViewer,
  indicator: IndicatorQuestionViewer,
  multipleAnswer: MultipleAnswerQuestionViewer,
  multipleChoice: MultiChoiceQuestionViewer,
  text: TextQuestionViewer,
};

interface IComponentProps {
  providers: IProviders;
  providerSurvey: IProviderItemViewWithData;
  dispatch: (action: any) => any;
  isOwnerOrSupport: boolean;
  readOnly: boolean;
  analyseSurvey: ISurveyViewWithData;
  analyseProviderSurvey: ISurveyItem;
  survey: ISurveyViewWithData;
  questionBankFolder: number | undefined;
  tags: IQuestionTags;
  company?: ICompany | undefined;
}

interface IWorksheetQuestion {
  question: string;
  options: Array<string>;
  correctOption: string;
  added: boolean;
}

interface IProposedQuestion {
  data: IQuestionsView;
  state: QuestionState;
}

interface IComponentState {
  displayDeleted: boolean;
  randomizEnabledQuestionsCount: number;
  randomizing: boolean;
  clipboardQuestion: any[] | undefined;
  showAdd: boolean;
  showFileExplorer: boolean;
  progress: string;
  currentPage: number;
  itemsPerPage: number;
  reIndexing: boolean;
  importedQuestions: IWorksheetQuestion[];
  savedImportedQuestions: boolean;
  savingImport: boolean;
  repeatedQuestions: string[];
  showInstructionsToImport: boolean;
  fillDurationInMinutes?: number;
  autoSelectRandomQuestions?: number;
  randomizeQuestions?: number;
  savingExamConfig?: boolean;
  randomizeOrder?: boolean;
  showAIChecklistGenerator: boolean;
  AIDescription: string;
  selectedFile: File | null;
  fetchingQuestionViaAILoading: boolean;
  AIPreviewedQuestionList: IQuestionsView[] | null;
  AIPreviewdDescription: string;
  proposedQuestion: Array<IProposedQuestion>;
  loadingInBulk: boolean;
  questionEditingLoadingState: {
    [key: number | string]: { editing: boolean; loading: boolean };
  };
}

interface IStateToProps {
  state: RootState;
}

interface IComponentProviders {
  [key: string]: {
    id: number;
    name: string;
    rootDocumentId: number;
  };
}

export const getChecklistIconViaType = (type: IQuestionsView['type']) => {
  let iconType: IconTypes;
  if (type === 'text') {
    iconType = 'align-center';
  } else if (type === 'file') {
    iconType = 'file';
  } else if (type === 'grid') {
    iconType = 'grid';
  } else if (type === 'multipleChoice') {
    iconType = 'check';
  } else if (type === 'multipleAnswer') {
    iconType = 'menu';
  } else {
    iconType = 'bookmark';
  }

  return <Icon type={iconType} />;
};

class SurveyEditor extends React.Component<
  IComponentProps & IStateToProps,
  IComponentState
> {
  protected providers: IComponentProviders;
  protected qList: React.RefObject<HTMLDivElement>;
  protected controller = new AbortController();
  protected questionMapValues;
  protected questionSetValuesFunction;

  constructor(props: IComponentProps & IStateToProps) {
    super(props);
    this.state = {
      displayDeleted: false,
      randomizEnabledQuestionsCount: 10,
      randomizing: false,
      clipboardQuestion: undefined,
      showAdd: false,
      savingImport: false,
      showFileExplorer: false,
      progress: '0',
      currentPage: 1, // Tracks the current chunk
      itemsPerPage: 30, // Number of items per chunk
      importedQuestions: [],
      repeatedQuestions: [],
      savedImportedQuestions: true,
      reIndexing: false,
      showInstructionsToImport: false,
      fillDurationInMinutes: props.survey.data.fillDurationInMinutes,
      autoSelectRandomQuestions: props.survey.data.autoSelectRandomQuestions,
      randomizeOrder: props.survey.data.randomizeOrder,
      showAIChecklistGenerator: false,
      selectedFile: null,
      fetchingQuestionViaAILoading: false,
      AIPreviewedQuestionList: null,
      loadingInBulk: false,
      proposedQuestion: [],
      AIDescription: '',
      AIPreviewdDescription: '',
      questionEditingLoadingState: {},
    };
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.qList = React.createRef();
    this.providers = {};
    this.questionMapValues = {};
    this.questionSetValuesFunction = {};
  }

  componentDidMount() {
    const { providerSurvey, dispatch } = this.props;
    const providerId = providerSurvey.data.providerId;
    dispatch(requireProviderTags({ providerId: providerId }));

    const provider = this.props.providers.map[providerId].data;
    this.providers = {
      [providerId]: {
        id: provider?.id as number,
        name: provider?.name as string,
        rootDocumentId: provider?.rootDocument.id as number,
      },
    };

    if (this.qList.current) {
      this.qList.current.addEventListener(
        'scroll',
        this.handleOnScroll.bind(this),
        {
          passive: true,
        }
      );
    }

    // Safely read clipboard with error handling
    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard
        .readText()
        .then((text) => {
          try {
            const json = JSON.parse(text);
            if (
              json &&
              json.type === 'question' &&
              json.surveyId !== this.props.survey.data.id
            )
              this.setState({ clipboardQuestion: json.value });
          } catch (e) {
            /*do nothing*/
          }
        })
        .catch(() => {
          // Silently fail if clipboard read is not allowed
        });
    }
  }

  componentWillUnmount() {
    if (this.qList.current) {
      this.qList.current.removeEventListener(
        'scroll',
        this.handleOnScroll.bind(this)
      );
    }
  }

  onChangeDisplayDeleted = (displayDeleted: boolean) => {
    this.setState({ displayDeleted });
  };

  handleCreateNewQuestion = (
    surveyData: ISurveyView,
    order: number,
    type: string
  ) => {
    const Question = questions[type];
    const questionId = getRandomInt(1, 1000);
    const question = new Question(questionId, '', order, '', false);
    this.props.dispatch(
      addQuestionAction({
        surveyId: surveyData.id as number,
        question: question,
      })
    );
    this.setState((prevState) => ({
      questionEditingLoadingState: {
        ...prevState.questionEditingLoadingState,
        [questionId]: { editing: true, loading: false },
      },
    }));
  };

  handleCreateNewQuestionPreviewAI = (
    surveyId: number,
    question: IQuestionsView
  ) => {
    if (question.id) {
      const questionId = question.id;
      const oldQuestion = this.props.survey.data.versions[
        this.props.survey.data.currentVersion
      ].questionList?.find((question) => question.id === questionId);
      return this.props.dispatch(
        updateQuestionAction({
          surveyId,
          oldQuestion: oldQuestion as IQuestionsView,
          newQuestion: question,
          enableEditing: true,
        })
      );
    }
    return this.props.dispatch(
      addQuestionAction({
        surveyId: surveyId as number,
        question: { ...question, id: getRandomInt(1, 1000) },
      })
    );
  };

  handleImportQuestionFromExcel = async (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ showAdd: false });
    const file = e.target.files?.[0];
    const surveyQuestionList = Object.values(
      this.props.survey.data.questionMap || {}
    ).reduce((acc: Array<string>, item: IQuestionsViewWithData) => {
      acc.push(item.data.title);
      return acc;
    }, []);
    if (file) {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(file as any);

      const worksheet = workbook.getWorksheet(1) as ExcelJS.Worksheet;
      const data: IWorksheetQuestion[] = [];
      let ansColNumber = 6;
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) {
          row.eachCell((cell, colNumber) => {
            if (cell.text.trim() === 'CorrectOption') ansColNumber = colNumber;
          });
        } else if (rowNumber > 1) {
          const question = row.getCell(1).text.trim(); // Question
          const option1 = row.getCell(2).text.trim(); // Option 1
          const option2 = row.getCell(3).text.trim(); // Option 2
          const option3 = row.getCell(4).text.trim(); // Option 3
          const option4 = row.getCell(5).text.trim(); // Option 4
          const correctOption = row.getCell(ansColNumber).text.trim(); // Correct ans

          // added: This option will be true while we want to add to the survey
          data.push({
            question: question,
            options: [option1, option2, option3, option4],
            correctOption:
              correctOption && isANumber(Number(correctOption))
                ? correctOption
                : '1',
            added: !surveyQuestionList.includes(question),
          });
        }
      });

      this.setState({
        importedQuestions: data,
        repeatedQuestions: surveyQuestionList,
        savedImportedQuestions: false,
      });
      // notify(messages.importedSuccessfully, 'successful');
    } else {
      notify(messages.errorInImportingExcel, 'warning');
    }
  };

  handleDragEnd = (result: {
    destination?: { index: number } | undefined | null;
    source?: { index: number } | undefined | null;
  }) => {
    const { survey, dispatch, providerSurvey } = this.props;
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const newIndex = result?.destination?.index;
    const oldIndex = result?.source?.index;
    // when order not changed do nothing
    if (newIndex === oldIndex) {
      return;
    }
    let newOrder;

    const sortedQuestion = Object.values(survey.data.questionMap || {})
      .sort((a: any, b: any) => a.data.order - b.data.order)
      .filter((i) => i.data.deleted === this.state.displayDeleted);
    let item = isANumber(oldIndex) ? sortedQuestion[oldIndex!] : null;

    if (newIndex === 0) {
      // dropped in first of list
      if (sortedQuestion.length === 0) {
        // dropped in empty list
        newOrder = 0;
      } else {
        const bottomItemOrder = sortedQuestion[newIndex].data.order;
        newOrder = bottomItemOrder - 1;
      }
    } else if (newIndex + 1 === sortedQuestion.length) {
      // dropped in end of list
      const topItemOrder = sortedQuestion[newIndex - 1].data.order;
      newOrder = topItemOrder + 1;
    } else if (isANumber(oldIndex) && newIndex > oldIndex!) {
      // pull down a list itemSortedQuestion
      const topItemOrder = sortedQuestion[newIndex].data.order;
      const bottomItemOrder = sortedQuestion[newIndex + 1].data.order;
      newOrder = (topItemOrder + bottomItemOrder) / 2;
    } else {
      // pull up a list item
      const topItemOrder = sortedQuestion[newIndex - 1].data.order;
      const bottomItemOrder = sortedQuestion[newIndex].data.order;
      newOrder = (topItemOrder + bottomItemOrder) / 2;
    }
    if (item) {
      item = {
        ...item,
        data: {
          ...item.data,
          order: newOrder,
        },
      };
      // update question
      dispatch(
        updateQuestion({
          questionData: item.data,
          providerSurveyData: providerSurvey.data as ISurveyItem,
        })
      );
    }
  };

  handleAICreateQuestion = async () => {
    this.setState({ fetchingQuestionViaAILoading: true });
    Notify(
      i18n.t('processMayTakeLonger', { ns: 'survey' }),
      'info',
      true,
      10000
    );
    this.controller = new AbortController();
    try {
      const res = await generateQuestionViaAI(
        this.props.state,
        this.state.AIDescription,
        this.props.survey.data.versions?.[
          this.props.survey.data.currentVersion
        ]?.questionList?.filter(
          (question: IQuestionsView) => !question.deleted
        ),
        this.state.selectedFile,
        this.controller
      );
      const createdQuestionList = res.data.form.questionsList;
      this.setState({
        AIPreviewdDescription: res.data.message,
        AIPreviewedQuestionList: createdQuestionList as any,
        fetchingQuestionViaAILoading: false,
      });
    } catch (e) {
      notifyError(e);
      this.setState({ fetchingQuestionViaAILoading: false });
    }
  };

  handleManipulateQuestionFromImportedExcel = (
    e: ChangeEvent<HTMLInputElement>,
    questionTitle: string
  ) => {
    const newQuestionList = this.state.importedQuestions.reduce(
      (acc: Array<IWorksheetQuestion>, item) => {
        if (item.question === questionTitle) {
          acc.push({
            ...item,
            added: e.target.checked,
          });
        } else {
          acc.push(item);
        }
        return acc;
      },
      []
    );
    this.setState({
      importedQuestions: newQuestionList,
    });
  };

  handleAddQuestionsToSurvey = () => {
    const maxOrder = Object.values(this.props.survey.data.questionMap!).reduce(
      (previousValue, currentValue) => {
        if (currentValue.data.order > previousValue)
          return currentValue.data.order;
        return previousValue;
      },
      0
    );
    const questionList = this.state.importedQuestions.reduce(
      (acc: Array<IMultipleChoiceQuestionView>, item, index: number) => {
        if (item.added)
          acc.push({
            id: Math.ceil(Math.random() * 100000000),
            title: item.question,
            type: 'multipleChoice',
            order: maxOrder + index + 1,
            choiceList: item.options.reduce(
              (acc: Array<IChoiceView>, option: string, index: number) => {
                acc.push({
                  text: option,
                  score: Number(item.correctOption) === index + 1 ? 1 : 0,
                  value: option,
                });
                return acc;
              },
              []
            ),
          } as IMultipleChoiceQuestionView);
        return acc;
      },
      []
    );

    this.setState({ savingImport: true });
    appDispatch(
      updateSurvey({
        surveyData: this.props.survey.data,
        providerSurveyItemData: this.props.providerSurvey.data as ISurveyItem,
        questionList,
      })
    )
      .then(() => {
        this.setState({
          savingImport: false,
          savedImportedQuestions: true,
        });
        notify(messages.questionsAddedToSurvey, 'successful');
      })
      .catch(() => {
        this.setState({
          savingImport: false,
        });
        notify(messages.questionsFailedToSurvey, 'error');
      });
  };

  handleDeclareAIQuestionStatus = (
    action: IQuestionsView['modificationType']
  ) => {
    if (action === 'edited') {
      return i18n.t('edited', { ns: 'survey' });
    } else if (action === 'created') {
      return i18n.t('created', { ns: 'survey' });
    } else if (action === 'deleted') {
      return i18n.t('deleted', { ns: 'survey' });
    } else {
      return i18n.t('withoutChange', { ns: 'survey' });
    }
  };

  // preview --> shows preview mode to add them manually
  // generate --> generate questions without preview mode
  handleCreateQuestionAI = async (mode: 'preview' | 'generate') => {
    this.setState({ fetchingQuestionViaAILoading: true });
    if (mode === 'preview') {
      // for edited question via AI
      const questionList = this.state.AIPreviewedQuestionList?.filter(
        (question: IQuestionsView) =>
          ['edited', 'deleted'].includes(question.modificationType as string)
      )?.map((question: IQuestionsView) => {
        const newStructureQuestion = {
          state: 'editing',
          data: { ...question, deleted: false },
        };
        if (
          question?.id &&
          Object.keys(this.questionSetValuesFunction).includes(
            question.id.toString()
          )
        ) {
          const formik = this.questionSetValuesFunction[question.id!];
          formik.setValues({
            ...formik.values,
            ...newStructureQuestion,
            data: {
              ...formik.values.data,
              ...newStructureQuestion.data,
            },
          });
        }
        return newStructureQuestion;
      });
      // for created questions via AI
      this.state.AIPreviewedQuestionList?.forEach(
        (question: IQuestionsView) => {
          if (question.modificationType === 'created') {
            const questionId = getRandomInt(1, 1000);
            appDispatch(
              addQuestionAction({
                surveyId: this.props.survey.data.id!,
                question: { ...question, id: questionId },
              })
            );
            this.setState((prev) => ({
              questionEditingLoadingState: {
                ...(prev.questionEditingLoadingState || {}),
                [questionId]: {
                  loading: false,
                  editing: true,
                },
              },
            }));
          } else if (
            question.modificationType &&
            ['edited', 'deleted'].includes(question.modificationType)
          ) {
            const oldQuestion =
              this.props.survey.data.versions?.[
                this.props.survey.data.currentVersion
              ]?.questionMap?.[question.id];
            if (oldQuestion) {
              appDispatch(
                updateQuestionAction({
                  surveyId: Number(this.props.survey.data.id),
                  oldQuestion,
                  newQuestion: { ...question, deleted: false },
                })
              );
              this.changeEditingLoadingState(question.id, { editing: true });
            }
          }
        }
      );
      this.setState({
        proposedQuestion: (questionList as IProposedQuestion[]) || [],
      });
    } else {
      const questionList =
        this.state.AIPreviewedQuestionList?.filter(
          (question: IQuestionsView) =>
            question.modificationType !== 'preserved'
        ) || [];
      for (let i = 0; i < (questionList?.length ?? 0); i++) {
        try {
          if (questionList![i].modificationType === 'created') {
            await appDispatch(
              addQuestion({
                questionData: {
                  ...questionList![i],
                  deleted: false,
                },
                providerSurveyData: this.props.providerSurvey
                  .data as ISurveyItem,
              })
            );
          } else {
            await appDispatch(
              updateQuestion({
                questionData: {
                  ...questionList![i],
                  deleted: questionList![i].modificationType === 'deleted',
                },
                providerSurveyData: this.props.providerSurvey
                  .data as ISurveyItem,
              })
            );
            this.changeEditingLoadingState(questionList![i].id, {
              editing: false,
              loading: false,
            });
          }
        } catch (error) {
          Notify(i18n.t('savingDataError', { ns: 'survey' }), 'error');
        }
      }
    }

    this.setState({
      fetchingQuestionViaAILoading: false,
      AIPreviewedQuestionList: null,
      showAIChecklistGenerator: false,
    });
  };

  handleSaveCreatingEditingQuestion = async () => {
    this.setState({ loadingInBulk: true });
    try {
      const proposedQuestionList = this.state.proposedQuestion;
      const proposedQuestionIDList = proposedQuestionList.map(
        (question: IProposedQuestion) => question.data.id
      );

      const questionList = [
        ...proposedQuestionIDList,
        ...Object.keys(this.state.questionEditingLoadingState)
          .filter(
            (id: string) =>
              !proposedQuestionIDList.includes(Number(id)) &&
              this.state.questionEditingLoadingState[id].editing
          )
          .map((id) => Number(id)),
      ];

      for (const questionIndex in questionList) {
        await this.updateQuestionFunction(
          this.questionMapValues[questionList[questionIndex]]
        );
      }
      this.setState({ proposedQuestion: [] });
      this.resetEditingQuestions();
    } catch (e) {
      Notify(i18n.t('failedSaving', { ns: 'survey' }), 'error');
    } finally {
      this.setState({ loadingInBulk: false });
    }
  };

  resetEditingQuestions = () => {
    Object.keys(this.state.questionEditingLoadingState).map((id: string) =>
      this.changeEditingLoadingState(Number(id), { editing: false })
    );
  };

  getAddQuestionComponent(surveyData: ISurveyView, getOrder: () => number) {
    let validQuestionTypes = QuestionType;
    const isExam = surveyData.surveyType === 'Exam';
    const isExamOrBank = isExam || surveyData.surveyType === 'Bank';
    if (isExamOrBank)
      validQuestionTypes = {
        MultipleChoice: 'multipleChoice',
      };
    if (!this.props.isOwnerOrSupport) {
      delete validQuestionTypes.MultipleAnswer;
    }

    const surveyQuestionList = Object.values(
      this.props.survey.data.questionMap || {}
    ).reduce((acc: Array<string>, item: IQuestionsViewWithData) => {
      acc.push(item.data.title);
      return acc;
    }, []);

    if (this.state.showAIChecklistGenerator) {
      const ownerOrSupport = this.props.isOwnerOrSupport;
      return (
        <Modal
          key="ai-checklist-generator"
          title={
            i18n.t('AIChecklistGeneratorTitle', {
              ns: 'survey',
            }) as string
          }
          onClose={() => {
            this.setState({
              showAIChecklistGenerator: false,
              selectedFile: null,
              AIDescription: '',
              AIPreviewedQuestionList: null,
            });
          }}
          isActive={this.state.showAIChecklistGenerator}
        >
          <div className="flex flex-col gap-5 h-full">
            {this.state.AIPreviewdDescription &&
              this.state.AIPreviewedQuestionList && (
                <NotificationContainer>
                  <NotificationBadgeContainer>
                    <Icon
                      type="info"
                      color={blue}
                      style={{ fontSize: '2rem' }}
                    />
                  </NotificationBadgeContainer>
                  <NotificationContentContainer>
                    <div>{this.state.AIPreviewdDescription}</div>
                  </NotificationContentContainer>
                </NotificationContainer>
              )}
            {this.state.AIPreviewedQuestionList ? (
              <>
                <PreviewTable>
                  <tr>
                    <th>
                      {i18n.t('questionTitle', { ns: 'survey' }) as string}
                    </th>
                    <th>
                      {i18n.t('questionStatus', { ns: 'survey' }) as string}
                    </th>
                    <th>
                      {
                        i18n.t('questionDescription', {
                          ns: 'survey',
                        }) as string
                      }
                    </th>
                  </tr>
                  {this.state.AIPreviewedQuestionList?.map(
                    (question: IQuestionsView) => {
                      const status = this.handleDeclareAIQuestionStatus(
                        question.modificationType
                      );
                      return (
                        <tr key={question.id}>
                          <td>
                            <div className="flex gap-1">
                              <>{getChecklistIconViaType(question.type)}</>
                              <p>{question.title}</p>
                            </div>
                          </td>
                          <td
                            style={{
                              color:
                                question.modificationType === 'deleted'
                                  ? red
                                  : question.modificationType === 'created'
                                    ? green
                                    : question.modificationType === 'edited'
                                      ? blue
                                      : black,
                            }}
                          >
                            {status}
                          </td>
                          <td>{question.modificationDesc}</td>
                        </tr>
                      );
                    }
                  )}
                </PreviewTable>
                <div
                  style={{
                    flex: '1',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                  }}
                >
                  <ButtonGroupContainer>
                    <Button
                      onClick={() => this.handleCreateQuestionAI('preview')}
                      loading={this.state.fetchingQuestionViaAILoading}
                      color="black-outline"
                    >
                      {i18n.t('createPreview', { ns: 'survey' }) as string}
                    </Button>
                    <Button
                      color="black-outline"
                      onClick={() => this.handleCreateQuestionAI('generate')}
                      loading={this.state.fetchingQuestionViaAILoading}
                    >
                      {
                        i18n.t('createQuestionCompletely', {
                          ns: 'survey',
                        }) as string
                      }
                    </Button>
                  </ButtonGroupContainer>
                </div>
              </>
            ) : (
              <>
                <NotificationContainer>
                  <NotificationBadgeContainer>
                    <Icon
                      type="info"
                      color={blue}
                      style={{ fontSize: '2rem' }}
                    />
                  </NotificationBadgeContainer>
                  <NotificationContentContainer>
                    <div>
                      <>{i18n.t('SurveyAIDescription', { ns: 'survey' })}</>
                    </div>
                  </NotificationContentContainer>
                </NotificationContainer>

                <ContentContainer>
                  <DragDropFilePicker
                    multiple={false}
                    contentText={i18n.t('dragDropUploadContentText', {
                      ns: 'survey',
                    })}
                    onDropRejected={(): void => {
                      this.setState({
                        selectedFile: null,
                      });
                    }}
                    accept={
                      '.doc,.docx,.xls,.xlsx,.pdf,\n' +
                      '         application/msword,\n' +
                      '         application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n' +
                      '         application/vnd.ms-excel,\n' +
                      '         application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n' +
                      '         application/pdf'
                    }
                    onDropAccepted={(files: File[]): void => {
                      this.setState({ selectedFile: files[0] });
                    }}
                  />

                  {this.state.selectedFile && (
                    <SelectedFileListContainer>
                      <Icon
                        color={red}
                        type={'x-circle'}
                        className={'flex items-center justify-center'}
                        style={{ fontSize: '1.5rem', cursor: 'pointer' }}
                        onClick={(event: any) => {
                          event.preventDefault();
                          this.setState({ selectedFile: null });
                        }}
                      />
                      <ItemsWrapper
                        key={`${this.state.selectedFile.lastModified}-${this.state.selectedFile.size}-${this.state.selectedFile.name}`}
                      >
                        <BadgeContainer bgColor={blue}>
                          <LocalIcon
                            iconName={checkFileFormat(
                              this.state.selectedFile.type as any
                            )}
                          />
                        </BadgeContainer>
                        <AttachedFileContent>
                          <div
                            style={{
                              position: 'relative',
                              top: '0',
                              overflow: 'hidden',
                              textAlign: 'center',
                            }}
                          >
                            {summerizeText(this.state.selectedFile.name, 10)}
                          </div>
                        </AttachedFileContent>
                      </ItemsWrapper>
                    </SelectedFileListContainer>
                  )}
                  <CKEditorField
                    label={i18n.t('description', { ns: 'survey' }) as string}
                    onChange={(_: any, editor: any) => {
                      const data = editor.getData();
                      this.setState({ AIDescription: data });
                    }}
                    data={this.state.AIDescription}
                    dir={`${languageDirection()}`}
                    config={CkEditorBaseConfig()}
                  />
                </ContentContainer>

                {ownerOrSupport && (
                  <ActionButtonContainer>
                    <Button
                      onClick={() => this.handleAICreateQuestion()}
                      loading={this.state.fetchingQuestionViaAILoading}
                      color={'blue-outline'}
                    >
                      <div className="flex gap-2 items-center justify-center">
                        <div>
                          {
                            i18n.t('createChecklistViaAI', {
                              ns: 'survey',
                            }) as string
                          }
                        </div>
                      </div>
                    </Button>
                    {this.state.fetchingQuestionViaAILoading && (
                      <Button
                        onClick={() => {
                          if (this.controller) this.controller.abort();
                        }}
                        color={'red-outline'}
                      >
                        {
                          i18n.t('cancelRequest', {
                            ns: 'survey',
                          }) as string
                        }
                      </Button>
                    )}
                  </ActionButtonContainer>
                )}
              </>
            )}
          </div>
        </Modal>
      );
    }

    if (!this.state.savedImportedQuestions) {
      return (
        <Modal
          key="importedQuestions"
          title={
            i18n.t('questionListFromExcel', {
              ns: 'survey',
            }) as string
          }
          onClose={() =>
            this.setState({
              savedImportedQuestions: true,
              showInstructionsToImport: false,
            })
          }
          isActive={
            !this.state.savedImportedQuestions ||
            this.state.showInstructionsToImport
          }
        >
          <div className="overflow-auto">
            {this.state.importedQuestions.map((question, index) => (
              <React.Fragment key={`${question.question}-${index}`}>
                <QuestionContainer>
                  <QuestionHeader>
                    <div className="flex items-center">
                      <AddQuestion>
                        <Input
                          id={`${question.question}-${index}`}
                          type="checkbox"
                          checked={question.added}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            this.handleManipulateQuestionFromImportedExcel(
                              e,
                              question.question
                            )
                          }
                        />
                      </AddQuestion>
                      <QuestionTitle>{`${index + 1}) ${question.question}`}</QuestionTitle>
                    </div>
                    <div className="flex gap-2">
                      {surveyQuestionList.includes(question.question) && (
                        <RepeatedQuestion>
                          {
                            i18n.t('isRepeatedQuestion', {
                              ns: 'survey',
                            }) as string
                          }
                        </RepeatedQuestion>
                      )}
                      <Answer>
                        {i18n.t('correctAnswer', { ns: 'survey' }) as string}:{' '}
                        {question.correctOption}
                      </Answer>
                    </div>
                  </QuestionHeader>
                  <QuestionOptionsWithAnswer>
                    <Options>
                      {question.options.map((option, optionIndex) => (
                        <AQuestionOption
                          key={`${question.question}-option-${optionIndex}`}
                        >
                          {`${optionIndex + 1}) ${option}`}
                        </AQuestionOption>
                      ))}
                    </Options>
                  </QuestionOptionsWithAnswer>
                </QuestionContainer>
              </React.Fragment>
            ))}

            <SaveButton>
              <Button
                onClick={this.handleAddQuestionsToSurvey}
                color="green"
                loading={this.state.savingImport}
                disabled={!this.state.importedQuestions.some((it) => it.added)}
              >
                {i18n.t('addImportedQuestion', { ns: 'survey' }) as string}
              </Button>
            </SaveButton>
          </div>
        </Modal>
      );
    }

    if (
      this.state.showInstructionsToImport &&
      this.state.savedImportedQuestions
    ) {
      return (
        <Modal
          key="instructions"
          title={i18n.t('questionListFromExcel', { ns: 'survey' }) as string}
          onClose={() => this.setState({ showInstructionsToImport: false })}
          isActive={
            this.state.showInstructionsToImport &&
            this.state.savedImportedQuestions
          }
        >
          <div className="overflow-auto">
            <InstructionsContainer>
              <InstructionsText>
                <div>
                  {
                    i18n.t('instructionImportExcel1', {
                      ns: 'survey',
                    }) as string
                  }
                </div>
                <div>
                  {
                    i18n.t('instructionImportExcel2', {
                      ns: 'survey',
                    }) as string
                  }
                </div>
                <div>
                  {
                    i18n.t('instructionImportExcel3', {
                      ns: 'survey',
                    }) as string
                  }
                </div>
                <div>
                  {
                    i18n.t('instructionImportExcel4', {
                      ns: 'survey',
                    }) as string
                  }
                </div>
              </InstructionsText>
              <ImportExcelContainer>
                <ImportLabelExcel htmlFor="file-input">
                  <input
                    id="file-input"
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={this.handleImportQuestionFromExcel}
                    style={{ display: 'none' }}
                  />
                  {i18n.t('importFromExcel', { ns: 'survey' }) as string}
                </ImportLabelExcel>
              </ImportExcelContainer>
            </InstructionsContainer>
          </div>
        </Modal>
      );
    }

    const creatingEditingQuestions =
      Object.values(this.state.questionEditingLoadingState || {}).some(
        (item: { editing: boolean; loading: boolean }) => item.editing
      ) || Object.values(this.state.proposedQuestion).length;

    return (
      <div className="flex items-center justify-center gap-5">
        {creatingEditingQuestions ? (
          <Button
            loading={this.state.loadingInBulk}
            color={'green'}
            onClick={this.handleSaveCreatingEditingQuestion}
          >
            {i18n.t('saveInBulk', { ns: 'survey' }) as string}
          </Button>
        ) : null}
        {this.props.isOwnerOrSupport && (
          <AIButton
            href=""
            onClick={(e: any) => {
              e.preventDefault();
              // let changeStateConfirmation = true;
              // if (creatingEditingQuestions)
              //   changeStateConfirmation = confirm(
              //     i18n.t('changesWillBeLost', { ns: 'survey' })
              //   );
              // if (changeStateConfirmation) {
              //   this.resetEditingQuestions();
              //   this.setState({
              //     showAIChecklistGenerator: true,
              //     showAdd: false,
              //   });
              // }
              this.resetEditingQuestions();
              this.setState({
                showAIChecklistGenerator: true,
                showAdd: false,
              });
            }}
          >
            <LocalIcon iconName={'gemini-logo.svg'} type="sm" />
            <div>{i18n.t('addQuestionWithAI', { ns: 'survey' }) as string}</div>
          </AIButton>
        )}
        <Dropdown
          marginToTarget={2}
          modifier={popperModifier}
          placement="bottom-end"
          width={220}
          show={this.state.showAdd}
          onShowChange={(value) => {
            if (navigator.clipboard && navigator.clipboard.readText) {
              navigator.clipboard.readText().then(
                (text) => {
                  try {
                    const json = JSON.parse(text);
                    if (
                      json &&
                      json.type === 'question' &&
                      json.surveyId !== surveyData.id
                    )
                      this.setState({ clipboardQuestion: json.value });
                  } catch (e) {
                    /*do nothing*/
                  } finally {
                    this.setState({ showAdd: value });
                  }
                },
                () => {
                  this.setState({ showAdd: value });
                }
              );
            } else {
              this.setState({ showAdd: value });
            }
          }}
          target={
            <Button color="green">
              <Icon className="right" type="plus-circle" />
              {`${i18n.t('addQuestion', { ns: 'survey' })}`}
            </Button>
          }
        >
          <Menu>
            {Object.values(validQuestionTypes).map((type) => {
              return (
                <MenuItem key={type}>
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleCreateNewQuestion(
                        surveyData,
                        getOrder(),
                        type
                      );
                    }}
                    style={{
                      display: 'flex',
                      gap: '0.5rem',
                      alignItems: 'center',
                    }}
                  >
                    <div>{getChecklistIconViaType(type)}</div>
                    <div>{`${i18n.t(`${type}`, { ns: 'survey' })}`}</div>
                  </span>
                </MenuItem>
              );
            })}
            {isExamOrBank && (
              <MenuItem key={'importExcel'}>
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      showInstructionsToImport: true,
                      showAdd: false,
                    });
                  }}
                >
                  {i18n.t('importFromExcel', { ns: 'survey' }) as string}
                </span>
              </MenuItem>
            )}
            {this.state.clipboardQuestion && (
              <MenuItem key={'paste'}>
                <span
                  onClick={async (e) => {
                    e.preventDefault();
                    const maxOrder = Object.values(
                      this.props.survey.data.questionMap || {}
                    ).reduce((previousValue, currentValue) => {
                      if (currentValue.data.order > previousValue)
                        return currentValue.data.order;
                      return previousValue;
                    }, 0);
                    for (
                      let i = 0;
                      i < (this.state.clipboardQuestion?.length ?? 0);
                      i++
                    ) {
                      const q = this.state.clipboardQuestion![i];
                      const question = { ...q, order: maxOrder + i + 1 };
                      const qExist =
                        this.props.survey.data.questionMap?.[question.id];
                      let newId = false;
                      if (qExist) {
                        if (!qExist.data.deleted) {
                          newId = confirm(
                            messages.questionExistUseNewId(question.title)
                          );
                          if (!newId) continue;
                        } else {
                          newId = true;
                        }
                      }
                      if (newId) question.id = undefined;
                      if (
                        question.viewCondition?.refQuestionId &&
                        !this.props.survey.data.questionMap?.[
                          question.viewCondition?.refQuestionId
                        ] &&
                        !this.state.clipboardQuestion?.some(
                          (it) =>
                            it.id === question.viewCondition?.refQuestionId
                        )
                      ) {
                        delete question.viewCondition;
                      }
                      if (e.shiftKey)
                        await appDispatch(
                          addQuestion({
                            questionData: { ...question },
                            providerSurveyData: this.props.providerSurvey
                              .data as ISurveyItem,
                            keepQuestionId: !newId,
                          })
                        );
                      else
                        this.props.dispatch(
                          addQuestionAction({
                            surveyId: surveyData.id as number,
                            question: {
                              ...question,
                              keepQuestionId: !newId,
                            },
                          })
                        );
                    }
                  }}
                >
                  {messages.pasteCopiedQuestion(
                    convertDigitToProperFormat(
                      this.state.clipboardQuestion.length.toString()
                    )
                  )}
                </span>
              </MenuItem>
            )}
            {isExam && (
              <>
                {' '}
                <MenuItem key={'import'}>
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ showFileExplorer: true, showAdd: false });
                    }}
                  >
                    {`${i18n.t('useQuestionBank', { ns: 'survey' })}`}
                  </span>
                </MenuItem>
              </>
            )}
          </Menu>
        </Dropdown>
      </div>
    );
  }

  reIndexResponses = () => {
    const { providerSurvey, dispatch } = this.props;
    this.setState({ reIndexing: true });
    dispatch(
      reindexSurvey({ providerSurveyData: providerSurvey.data as ISurveyItem })
    ).then(
      (res: any) => {
        this.setState({ reIndexing: false });
        const indexNum = res?.payload?.survey || 0;
        notify(messages.indexed(indexNum));
      },
      (e: any) => {
        notifyError(e);
        this.setState({ reIndexing: false });
      }
    );
  };
  randomizeEnabledQuestions = async () => {
    this.setState({ randomizing: true });
    const questionMap = this.props?.survey?.data?.questionMap;
    const questionIds = Object.values(questionMap || {})
      .filter((it) => !it.data.deleted)
      .map((it) => it.data.id)
      .sort(() => Math.random() - 0.5);
    for (const i of questionIds) {
      const index = questionIds.indexOf(i);
      const newQuestion = cloneDeep(questionMap?.[i].data);
      const oldDisabled = newQuestion?.disabled;
      if (newQuestion) {
        newQuestion.disabled =
          index >= this.state.randomizEnabledQuestionsCount;
        if (oldDisabled !== newQuestion.disabled)
          await this.props.dispatch(
            updateQuestion({
              questionData: newQuestion,
              providerSurveyData: this.props.providerSurvey.data as ISurveyItem,
            })
          );
      }
    }
    this.setState({ randomizing: false });
  };

  getRenderIds = (survey: ISurveyViewWithData) => {
    const surveyData = survey.data;
    const showingActiveVersion =
      surveyData.currentVersion === survey.viewingVersion;
    const questionMap = showingActiveVersion
      ? surveyData.questionMap
      : Object.values(
          surveyData.versions?.[this.props.survey.viewingVersion as string]
            ?.questionMap || {}
        ).reduce((listObj: any, item: any) => {
          if (item) {
            listObj[item.id] = { data: item, state: 'exists' };
          }
          return listObj;
        }, {});
    let orderedQuestionIs = Object.keys(questionMap || {}).sort((a, b) => {
      if (questionMap?.[a]?.data?.order === undefined) {
        return 1;
      }
      if (questionMap?.[b]?.data?.order === undefined) {
        return -1;
      }
      return questionMap?.[a].data.order - questionMap?.[b].data.order;
    });
    let maxOrder = 0;
    let deletedCount = 0;
    orderedQuestionIs = orderedQuestionIs.filter((item) => {
      const question = questionMap?.[item];
      if (question?.data?.order > maxOrder) maxOrder = question.data.order;
      const notDeleted = !question?.data?.deleted;
      if (!notDeleted) {
        deletedCount += 1;
      }
      return notDeleted || this.state.displayDeleted;
    });

    return {
      orderedQuestionIs,
      showingActiveVersion,
      surveyData,
      maxOrder,
      deletedCount,
      questionMap,
    };
  };

  handleRemoveQuestion = (questionId: number) => {
    this.setState({
      proposedQuestion: this.state.proposedQuestion?.filter(
        (question: IProposedQuestion) => question.data.id !== questionId
      ),
    });
  };

  changeEditingLoadingState = (
    questionId: number,
    questionState: { editing?: boolean; loading?: boolean }
  ) => {
    this.setState((prev) => ({
      questionEditingLoadingState: {
        ...(prev.questionEditingLoadingState || {}),
        [questionId]: {
          ...(prev.questionEditingLoadingState?.[questionId] || {}),
          ...questionState,
        },
      },
    }));
  };

  updateQuestionFunction = async (values: IFormValues) => {
    const {
      analyseSurvey,
      analyseProviderSurvey: secondaryProviderSurvey,
      providerSurvey,
    } = this.props;

    const { state, data } = values;

    this.changeEditingLoadingState(data.id, { loading: true });

    const secondaryQuestion = analyseSurvey?.data?.questionMap?.[data.id];

    const hospitalTagIdTmp = secondaryProviderSurvey?.providerId
      ? Object.values(
          this.props.state.providers.tags[secondaryProviderSurvey.providerId]
            ?.data || {}
        )?.find((it) => it.text === 'بیمارستان')?.id
      : undefined;
    const hospitalTagId = hospitalTagIdTmp
      ? Number(hospitalTagIdTmp)
      : undefined;
    const secondaryFillPermissionSchemeList = (values.data as any)
      .secondaryFillPermissionSchemeList;
    const secondaryReportPermissionSchemeList = (values.data as any)
      .secondaryReportPermissionSchemeList;
    delete data['secondaryReportPermissionSchemeList'];
    delete data['secondaryFillPermissionSchemeList'];
    if (state === 'creating') {
      const keepQuestionId = data['keepQuestionId'];
      delete data['keepQuestionId'];
      try {
        await appDispatch(
          addQuestion({
            questionData: data,
            providerSurveyData: providerSurvey.data as ISurveyItem,
            keepQuestionId,
            enableEditing: false,
          })
        );
        this.changeEditingLoadingState(data.id, {
          loading: false,
          editing: false,
        });
      } catch (err) {
        this.changeEditingLoadingState(data.id, {
          loading: false,
          editing: false,
        });
        display(err);
      }
    } else {
      try {
        await appDispatch(
          updateQuestion({
            questionData: {
              ...data,
              deleted: data.modificationType === 'deleted',
            },
            providerSurveyData: providerSurvey.data as ISurveyItem,
          })
        );
        this.changeEditingLoadingState(data.id, {
          loading: false,
          editing: false,
        });
      } catch (err) {
        this.changeEditingLoadingState(data.id, {
          loading: false,
          editing: false,
        });
        display(err);
      }
      if (secondaryQuestion && secondaryProviderSurvey) {
        const hasHospital = !!hospitalTagId;
        const clone = cloneDeep(data) as IMultipleChoiceQuestionView;
        if (hasHospital)
          clone.tagChoices = [...(clone.tagChoices || []), hospitalTagId!];
        clone.fillPermissionSchemeList = secondaryFillPermissionSchemeList;
        clone.reportPermissionSchemeList = secondaryReportPermissionSchemeList;
        await appDispatch(
          updateQuestion({
            questionData: clone,
            providerSurveyData: secondaryProviderSurvey,
          })
        );
      }
    }
  };

  preRenderList() {
    const {
      tags,
      dispatch,
      providerSurvey,
      survey,
      company,
      analyseSurvey,
      analyseProviderSurvey,
      readOnly,
      isOwnerOrSupport,
    } = this.props;

    const {
      orderedQuestionIs,
      showingActiveVersion,
      surveyData,
      maxOrder,
      deletedCount,
      questionMap,
    } = this.getRenderIds(survey);

    const renderList: any[] = [];

    orderedQuestionIs.forEach((itm, idx) => {
      let question = questionMap?.[itm];
      const QuestionViewer = questionViewers[question.data?.type];
      const secondaryQuestion = analyseSurvey?.data?.questionMap?.[itm];

      const hasProposedQuestion = this.state.proposedQuestion.find(
        (q: IProposedQuestion) => q.data.id === Number(itm)
      );
      if (hasProposedQuestion) question = hasProposedQuestion;
      renderList.push(
        <Formik
          key={question.data.id}
          onSubmit={this.updateQuestionFunction}
          initialValues={{
            ...question,
            data: {
              ...question.data,
              secondaryFillPermissionSchemeList: (
                secondaryQuestion?.data as any
              )?.fillPermissionSchemeList,
              secondaryReportPermissionSchemeList: (
                secondaryQuestion?.data as any
              )?.reportPermissionSchemeList,
            },
          }}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {(formikProps: FormikProps<any>) => {
            this.questionMapValues = {
              ...this.questionMapValues,
              [question.data?.id]: formikProps.values,
            };

            if (
              !Object.keys(this.questionSetValuesFunction).includes(
                question.data?.id
              )
            ) {
              this.questionSetValuesFunction = {
                ...this.questionSetValuesFunction,
                [question.data?.id]: formikProps,
              };
            }

            return (
              <QuestionViewer
                key={question.data.id}
                tags={tags}
                index={idx}
                dispatch={dispatch}
                question={question}
                readOnly={!showingActiveVersion || readOnly}
                surveyId={surveyData.id}
                survey={surveyData}
                providerSurvey={providerSurvey}
                secondaryProviderSurvey={analyseProviderSurvey}
                secondaryQuestion={secondaryQuestion}
                displayDeleted={this.state.displayDeleted}
                isOwnerOrSupport={isOwnerOrSupport}
                company={company}
                onRemoveQuestion={this.handleRemoveQuestion}
                questionState={
                  this.state.questionEditingLoadingState[question.data.id]
                }
                changeQuestionState={this.changeEditingLoadingState}
              />
            );
          }}
        </Formik>
      );
    });

    return {
      showingActiveVersion,
      surveyData,
      maxOrder,
      deletedCount,
      renderList,
    };
  }

  handleOnScroll = () => {
    if (this.qList.current) {
      const boundary = 10;
      const scrollTop = this.qList.current.scrollTop || document.body.scrollTop;
      const scrollHeight =
        this.qList.current.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        this.qList.current.clientHeight || window.innerHeight;
      const scrolledToBottom =
        Math.ceil(scrollTop + clientHeight) >= scrollHeight - boundary;

      if (scrolledToBottom) {
        this.handleLoadMore();
      }
    }
  };

  // Method to load the next chunk
  handleLoadMore() {
    this.setState((prevState) => ({
      currentPage: prevState.currentPage + 1,
    }));
  }

  // Get the paginated render list
  getPaginatedRenderList(renderList: any[]) {
    const { currentPage, itemsPerPage } = this.state;
    const startIndex = 0;
    const endIndex = currentPage * itemsPerPage;
    return renderList.slice(startIndex, endIndex);
  }

  render() {
    const { survey, readOnly } = this.props;
    const { reIndexing } = this.state;
    const isLoading = survey.isLoading;

    if (isLoading !== false) {
      return <p>loading...</p>;
    }

    const {
      showingActiveVersion,
      surveyData,
      maxOrder,
      deletedCount,
      renderList,
    } = this.preRenderList();
    const paginatedList = this.getPaginatedRenderList(renderList);

    return (
      <div style={{ paddingBottom: '0' }} className="modal-content flex-box">
        <div
          ref={(_: any) => {
            // Note: Todo ( point of using the following line
            // this.questionList = el;
          }}
          id="reference-wrapper"
          style={{
            height: 'calc(100% - 10px)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!readOnly && surveyData.surveyType === 'Exam' && (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '1rem',
              }}
            >
              <Input
                id="fillDurationInMinutes"
                type="number"
                value={
                  this.state.fillDurationInMinutes !== 0
                    ? this.state.fillDurationInMinutes
                    : ''
                }
                min={0}
                label={i18n.t('examDuration', { ns: 'survey' }) as string}
                placeholder={i18n.t('noLimit', { ns: 'survey' })}
                onChange={(e) => {
                  this.setState({
                    fillDurationInMinutes: Number(e.target.value),
                  });
                }}
              />
              <Input
                id="autoSelectRandomQuestions"
                type="number"
                value={
                  this.state.autoSelectRandomQuestions !== 0
                    ? this.state.autoSelectRandomQuestions
                    : ''
                }
                min={0}
                label={
                  i18n.t('questionRandomization', { ns: 'survey' }) as string
                }
                placeholder={i18n.t('allQuestions', { ns: 'survey' })}
                onChange={(e) => {
                  this.setState({
                    autoSelectRandomQuestions: Number(e.target.value),
                  });
                }}
              />
              <Input
                id="random"
                type="checkbox"
                checked={this.state.randomizeOrder}
                label={i18n.t('randomizeOrder', { ns: 'survey' }) as string}
                onChange={(e) => {
                  this.setState({
                    randomizeOrder: e.target.checked,
                  });
                }}
              />
              {(this.state.fillDurationInMinutes !==
                surveyData.fillDurationInMinutes ||
                this.state.autoSelectRandomQuestions !==
                  surveyData.autoSelectRandomQuestions ||
                this.state.randomizeOrder !== surveyData.randomizeOrder) && (
                <Button
                  color="red"
                  onClick={() => {
                    this.setState({ savingExamConfig: true });
                    appDispatch(
                      updateSurvey({
                        surveyData: {
                          ...surveyData,
                          autoSelectRandomQuestions:
                            this.state.autoSelectRandomQuestions,
                          fillDurationInMinutes:
                            this.state.fillDurationInMinutes,
                          randomizeOrder: this.state.randomizeOrder || false,
                        },
                        providerSurveyItemData: this.props.providerSurvey
                          .data as ISurveyItem,
                      })
                    )
                      .then(() => {
                        notify(i18n.t('updated'));
                      })
                      .finally(() => {
                        this.setState({ savingExamConfig: false });
                      });
                  }}
                  loading={this.state.savingExamConfig}
                >
                  {i18n.t('save', { ns: 'survey' }) as string}
                </Button>
              )}
            </div>
          )}

          <SurveyEditorHeaderWrapper>
            <h5
              className="no-margin green-text text-darken-2"
              style={{ display: 'inline-block' }}
            >
              {`${i18n.t('questionList', { ns: 'survey' })}`}
            </h5>
            {showingActiveVersion && !readOnly ? (
              this.getAddQuestionComponent(surveyData, () => maxOrder + 1)
            ) : (
              <QuestionHintBox>
                <HintIcon type="info" />
                <HintText>
                  <span>{`${i18n.t('canNotChangeNotActiveVersion', { ns: 'survey' })}`}</span>
                </HintText>
              </QuestionHintBox>
            )}
          </SurveyEditorHeaderWrapper>
          {deletedCount !== 0 ? (
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                color: black,
                paddingBottom: '0.5rem',
                alignItems: 'center',
              }}
            >
              <div>{messages.deletedQuestion(deletedCount)}</div>
              <Button
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  this.onChangeDisplayDeleted(!this.state.displayDeleted);
                }}
                color="black-outline"
                style={{ padding: '0.1rem 1rem', borderRadius: '0.5rem' }}
              >
                {this.state.displayDeleted
                  ? (i18n.t('hide', { ns: 'survey' }) as string)
                  : (i18n.t('show', { ns: 'survey' }) as string)}
              </Button>
            </div>
          ) : null}

          {/* @ts-expect-error JSX Error */}
          <DragDropContext onDragEnd={this.handleDragEnd}>
            <Droppable droppableId="droppable-1">
              {(provided) => (
                <List
                  className="collapsible"
                  style={{ padding: '0', borderRadius: '1rem' }}
                  ref={mergeRefs(provided.innerRef, this.qList)}
                  {...provided.droppableProps}
                >
                  {paginatedList}
                  {provided.placeholder}
                </List>
              )}
            </Droppable>
          </DragDropContext>
          {/*{paginatedList.length < renderList.length && (*/}
          {/*  <button onClick={this.handleLoadMore}>Load More</button>*/}
          {/*)}*/}
        </div>
        {!readOnly && surveyData.surveyType !== 'Bank' && (
          <>
            <APopover
              arrow
              curveBorder
              trigger="click"
              target={
                <Button color="red-outline">
                  {i18n.t('reIndexResponses', { ns: 'survey' }) as string}
                </Button>
              }
            >
              <div>
                <QuestionHintBox>
                  <HintIcon type="info" />
                  <HintText>
                    <div>
                      {i18n.t('reindexNote', { ns: 'survey' }) as string}
                    </div>
                  </HintText>
                </QuestionHintBox>
                <Button
                  color="red-outline"
                  onClick={this.reIndexResponses}
                  loading={reIndexing}
                >
                  {i18n.t('reIndexResponses', { ns: 'survey' }) as string}
                </Button>
              </div>
            </APopover>
          </>
        )}

        {this.state.showFileExplorer && (
          <QuestionExplorerModal
            onClose={() => {
              this.setState({ showFileExplorer: false });
            }}
            providers={this.providers}
            itemId={this.props.providerSurvey.data.id}
            providerId={this.props.providerSurvey.data.providerId}
            targetSurvey={this.props.survey.data}
            targetItem={this.props.providerSurvey}
            allowedQuestionTypes={['multipleChoice']}
            rootFolderId={this.props.questionBankFolder}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  IComponentState,
  RootState
> = (state) => {
  return { state };
};

export default connect(mapStateToProps)(SurveyEditor);
